module.exports = __webpack_public_path__ + "img/base_restauration_gastronomique.dd4edbde.svg";